import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template as SuccessStoriesTemplate } from "./success-stories.templates";

export default {
    title: "Website/Partial Templates/Success Stories",
    render: SuccessStoriesTemplate.bind({}),
    tags: ["autodocs"],
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        mockDataUrl: "./generated-mock-data/success-stories.json",
        withPreview: false,
    },
};

export const Default = {};

export const WithPreview = {
    args: {
        withPreview: true,
    },
};
